<template>
  <div class="contractUsPage">
    <div class="header-banner-container">
      <headerCom ref="headerComDom"></headerCom>
      <div class="head-banner-content">
        <div class="head-banner-title">联系我们</div>
        <div class="head-banner-subtitle">让我们一起讨论解决方案</div>
      </div>
    </div>
    <div class="main-container">
        <!--预约上门评估--->
        <div class="main-content">
            <div class="main-assess-container">
                <div class="main-assess-header">
                    <!--
                    <div class="main-assess-close-img-container">
                        <img class="main-assess-close-img" src="../assets/icon_close_black.png">
                    </div>
                    -->
                    <div class="main-assess-header-content">
                        <div class="main-assess-title-container">
                            <div class="main-assess-title-cosmetic-line"></div>
                            <div class="main-assess-title">预约上门评估</div>
                            <div class="main-assess-title-cosmetic-line"></div>
                        </div>
                        <div class="main-assess-header-info-content">
                            <div class="main-assess-header-info">
                                <img class="main-assess-header-phrase-icon" src="../assets/home_popup_icon_service.png">
                                <div class="main-assess-header-phrase">2小时一对一咨询沟通</div>
                                <div class="clearboth"></div>
                            </div>
                            <div class="main-assess-header-info">
                                <img class="main-assess-header-phrase-icon" src="../assets/home_popup_icon_service.png">
                                <div class="main-assess-header-phrase">提效降险节流人事管理方案</div>
                                <div class="clearboth"></div>
                            </div>
                            <div class="main-assess-header-info">
                                <img class="main-assess-header-phrase-icon" src="../assets/home_popup_icon_service.png">
                                <div class="main-assess-header-phrase">分析自雇HR与外包成本</div>
                                <div class="clearboth"></div>
                            </div>
                            <div class="main-assess-header-info">
                                <img class="main-assess-header-phrase-icon" src="../assets/home_popup_icon_service.png">
                                <div class="main-assess-header-phrase">突发纠纷或问题员工紧急处理</div>
                                <div class="clearboth"></div>
                            </div>
                            <div class="clearboth"></div>
                        </div>
                    </div>
                </div>
                <div class="main-assess-content">
                    <div class="main-assess-input">
                        <label>您的姓名</label>
                        <input ref="name" v-model="name" type="text" placeholder="请输入您的姓名" maxlength="100"/>
                    </div>
                    <div class="main-assess-input">
                        <label>您的联系电话</label>
                        <input ref="phone" v-model="phone" type="text" placeholder="请输入您的联系电话" maxlength="100"/>
                    </div>
                    <div class="main-assess-input">
                        <label>其他联系方式（选填）</label>
                        <input v-model="contact" type="text" placeholder="例：微信号123456" maxlength="200"/>
                    </div>
                    <div class="main-assess-input">
                        <label>您还想通过咨询获得什么？（选填）</label>
                        <textarea v-model="demand" rows="4" cols="20" placeholder="请输入您的需求" maxlength="1000"></textarea>
                    </div>
                    <div class="main-assess-activity">
                        <div class="main-assess-activity-txt">限时活动</div>
                        <div class="main-assess-activity-info">
                            <img class="main-assess-activity-checkbox" @click="changeActivityCheckboxIconSrc()" :src="activityCheckboxIconSrc">
                            <div class="main-assess-activity-info-txt">预约免费上门评估服务&nbsp;-&nbsp;2小时面对面沟通</div>
                            <div class="clearboth"></div>
                        </div>
                    </div>
                    <div class="main-assess-input" v-if="isJoin==1">
                        <label>请填写合适的上门服务时间</label>
                        <input ref="serviceTime" v-model="serviceTime" type="text" :placeholder="'例：'+dateFormatPlaceHolderTime(placeHolderTime)" />
                    </div>
                    <div class="main-assess-txt">我们收到您的消息后将与您进行确认，请留意我们的后续联系</div>
                    <div class="main-assess-btn" @click="toConsult($event)">马上预约</div>
                </div>

            </div>
        </div>

        <!--我们的联系方式 -->
        <div class="main-content">
            <div class="main-content-title-container">
                <div class="main-content-title">我们的联系方式</div>
                <div class="clearboth"></div>
            </div>
            <div class="main-contact-container">
                <div class="main-contact-phrase">
                    <img class="main-contact-phrase-img" src="../assets/contact us_icon_phone_number.png">
                    <div class="main-contact-phrase-txt">022-84476135</div>
                    <div class="clearboth"></div>
                </div>
                <div class="main-contact-phrase">
                    <img class="main-contact-phrase-img" src="../assets/contact us_icon_email.png">
                    <div class="main-contact-phrase-txt">info@huifeng1997.cn</div>
                    <div class="clearboth"></div>
                </div>
                <div class="clearboth"></div>
                <div class="main-contact-phrase">
                    <img class="main-contact-phrase-img" src="../assets/contact us_icon_address.png">
                    <div class="main-contact-phrase-txt">天津空港经济区西七道1号凤凰墅69号楼</div>
                    <div class="clearboth"></div>
                </div>
                <div class="main-contact-phrase" @mouseenter="changeWechatHover" @mouseleave="changeWechatHover">
                    <img class="main-contact-phrase-img" src="../assets/contact us_icon_wechat.png">
                    <div class="main-contact-phrase-txt">微信二维码</div>
                    <div class="clearboth"></div>
                    <div class="main-contact-wechat-hover" v-if="wechatHover">
                        <div class="main-contact-wechat-hover-img-container">
                            <img class="main-contact-wechat-hover-img" src="../assets/qrcode.jpg">
                        </div>
                    </div>
                </div>
                <div class="clearboth"></div>
            </div>
            <div class="main-map-container">
                <div id="bmap" class="main-map-in"></div>
            </div>
        </div>

    </div>


    <foot></foot>

    <popup
      v-if="showPromptSuccess"
      :showPromptSuccess="showPromptSuccess" :promptTxt="isJoin==1?'您的2小时免费评估上门评估预约信息已成功发送，我们将尽快与您确认，请耐心等候！': '您的咨询信息已成功发送，<br>我们将在约定的时间与您联系，感谢您的支持！'"
      @closePop="closePop"></popup>

  </div>

</template>

<script>
  import headerCom from '@/components/Header.vue';
  import foot from '@/components/Footer.vue';
  import popup from '@/components/popup.vue';
  import axios from "axios";

  export default {
    data() {
      return {
        showPromptSuccess: false,

        //免费上门预约弹窗-s
        name: "",//姓名
        phone: "",//联系电话
        contact: "",//其他联系方式
        demand: "",//需求
        isJoin: 1,//限时活动
        serviceTime: "",//上门服务时间
        //免费上门预约弹窗-e

        activityCheckboxIconSrc: require('../assets/form_activity_icon_selected.png'),

        wechatHover: false,

        placeHolderTime: new Date(),
      }
    },
    components: {
      headerCom,
      foot,
      popup
    },
    created() {
       document.title = '联系我们_薪领航管理咨询有限公司';
    },
    mounted() {

      //百度地图
      var map=new BMap.Map("bmap")
      // 创建地图实例
      var point=new BMap.Point(117.402385, 39.142656)
      // 创建点坐标
      map.centerAndZoom("天津空港经济区西七道1号凤凰墅69号楼", 18)
      map.addControl(new BMap.ScaleControl())
      //map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      var marker=new BMap.Marker(point) // 创建标注
      map.addOverlay(marker)


      var Finger = sessionStorage.getItem("Finger")
      if(Finger==null || Finger==""){
        let excludes = {};
        let options = {
          excludes: excludes
        }
        //console.log(options)
        Fingerprint2.get(options, function(components) {
          // 参数
          const values = components.map(function(component) {
            return component.value
          });
          // 指纹
          const murmur = Fingerprint2.x64hash128(values.join(''), 31);
          // view.innerHTML += '<p class="pp">标识 : ' + murmur + '</p>';
          sessionStorage.setItem("Finger", murmur); //存入标识值
          //console.log(murmur);
        });
      }

      document.addEventListener("click", (e) => {
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,0,0,x,y);
      });
    },
    methods: {
      //格式化当前日期 提示文字 xx年xx月xx日上午x点
      dateFormatPlaceHolderTime(time) {
        var date = new Date(time);
        var year=date.getFullYear();
        var month= date.getMonth()+1;
        var day=date.getDate();
        var hours=date.getHours()<12 ? "上午"+date.getHours() : "下午"+(date.getHours()-12);

        return year+"年"+month+"月"+day+"日"+hours+"点";
      },
      //弹窗限时活动，点击改src
      changeActivityCheckboxIconSrc(){
          if(this.isJoin == 1){
              this.isJoin = 2
          }else{
              this.isJoin = 1
          }
          switch (this.isJoin) {
          case 1:
              this.activityCheckboxIconSrc = require('../assets/form_activity_icon_selected.png')
              break
          case 2:
              this.activityCheckboxIconSrc = require('../assets/form_activity_icon_unselected.png')
              break
          }
      },

      //关闭弹窗
      closePop(){
        this.showPromptSuccess = false;
        document.body.removeAttribute('style');
      },

      //打开 成功提示 弹窗
      toShowPromptSuccess(){
        this.showPromptSuccess = true;
        document.querySelector('body').setAttribute('style', 'width: 100%;height: 100%;overflow: hidden;');
      },

      //提交 预约上门评估
      toConsult(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,2,0,x,y);
        if(this.name==""){
            alert("请填写您的姓名")
            this.$refs.name.focus()
            return false
        }
        if(this.phone==""){
            alert("请填写您的联系电话")
            this.$refs.phone.focus()
            return false
        }
        if(this.isJoin==1 && this.serviceTime==""){
            alert("请填写上门服务时间")
            this.$refs.serviceTime.focus()
            return false
        }
        let params = {};
        params.type = 1;
        params.name = this.name;//姓名
        params.phone = this.phone;//联系电话
        params.contact = this.contact;//其他联系方式
        params.demand = this.demand;//需求
        params.isJoin = this.isJoin;//限时活动
        params.serviceTime = this.serviceTime;//上门服务时间
        params.browserId = sessionStorage.getItem("Finger");//浏览器标识
        axios
          .post("pilotage/webConsult", params)
          .then((res) => {
            if(res.data.success!=null && res.data.success==1){
                this.toShowPromptSuccess()
            }else if(res.data.success!=null && res.data.success==3){
                alert("您已提交，请勿重复提交，请耐心等待回复！")
            }else{
              alert("提交失败，请您重新提交！")
            }
          })
          .catch((res) => {
            alert("提交失败，请您重新提交！")
          });

      },
      //微信二维码悬浮 显示二维码
      changeWechatHover(){
          this.wechatHover = !this.wechatHover
      },
    },
  }
</script>

<style>
  .contractUsPage .header-banner-container {
    background: url('../assets/contactUs_heroBanner_bg_img.png');
    background-size: cover;
    padding-bottom: 29.166%;
    /*2880*840图片高宽比*/
    position: relative;
  }

  .contractUsPage .main-content {
    text-align: center;
  }

  .contractUsPage .main-content-title {
    background: url('../assets/Line5.png') no-repeat;
    background-size: 100% 5px;
    background-position: 0% 60%;
  }

  .main-assess-container {
    width: 740px;
    height: auto;
    margin: auto;
    margin: 40px auto auto auto;
  }

  .main-assess-header {
    background: #1055C1;
    position: relative;
    width: 100%;
  }

  .main-assess-close-img-container {
    cursor: pointer;
    position: absolute;
    top: 29px;
    right: 34px;
  }

  .main-assess-close-img {
    width: 24px;
    height: auto;
  }

  .main-assess-header-content {
    padding: 20px 0 24px 0;
    text-align: center;
  }

  .main-assess-title-container {
    font-size: 0;
  }

  .main-assess-title-cosmetic-line {
    width: 100px;
    height: 1.2px;
    margin: 10px 20px;
    display: inline-block;
  }

  .main-assess-title-container .main-assess-title-cosmetic-line:first-child {
    background-image: linear-gradient(to right, rgb(255, 255, 255, 0), rgb(255, 255, 255, 1));
  }

  .main-assess-title-container .main-assess-title-cosmetic-line:nth-child(3) {
    background-image: linear-gradient(to right, rgb(255, 255, 255, 1), rgb(255, 255, 255, 0));
  }

  .main-assess-title {
    font-family: Noto Sans SC;
    font-size: 26px;
    line-height: 36px;
    color: #FFFFFF;
    display: inline-block;
  }

  .main-assess-header-info-content {
    margin: 20px 0 0 0;
  }

  .main-assess-header-info {
    float: left;
    margin: 16px 0 0 0;
    height: 28px;
  }

  .main-assess-header-info:nth-child(-n+2) {
    margin-top: 0px;
  }

  .main-assess-header-info:nth-child(odd) {
    margin-left: 145px;
  }

  .main-assess-header-phrase-icon {
    height: 24px;
    width: auto;
    float: left;
    margin: 2px 4px 0 0;
  }

  .main-assess-header-phrase {
    font-family: Noto Sans SC;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    width: 208px;
    float: left;
    text-align: left;
  }

  .main-assess-content {
    background: #EEF4FE;
    text-align: center;
    padding: 20px 0;
  }

  .main-assess-input {
    margin: 15px 0px 0 0;
  }

  .main-assess-content .main-assess-input:first-child {
    margin-top: 0px;
  }

  .main-assess-input label {
    text-align: left;
    font-family: Noto Sans SC;
    font-weight: 300;
    font-size: 16px;
    line-height: 21px;
    color: #333333;
    display: block;
    margin: 0 0 0 110px;
  }

  .main-assess-input input {
    margin: 8px 0 0 0;
    width: 500px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #FFFFFF;
    padding: 0 8px;
    font-size: 16px;
    line-height: 24px;
    font-family: Noto Sans SC;
    color: #333333;
  }

  .main-assess-input textarea {
    margin: 8px 0 0 0;
    width: 500px;
    height: 120px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #FFFFFF;
    resize: none;
    padding: 8px 8px;
    font-size: 16px;
    line-height: 24px;
    font-family: Noto Sans SC;
    color: #333333;
  }

  .main-assess-input input::-webkit-input-placeholder {
    color: #B7CCED;
    font-family: Noto Sans SC;
    font-weight: 300;
    font-size: 16px;
    line-height: 40px;
  }

  .main-assess-input input:-moz-placeholder {
    color: #B7CCED;
    font-family: Noto Sans SC;
    font-weight: 300;
    font-size: 16px;
    line-height: 40px;
  }

  .main-assess-input input:-ms-input-placeholder {
    color: #B7CCED;
    font-family: Noto Sans SC;
    font-weight: 300;
    font-size: 16px;
    line-height: 40px;
  }

  .main-assess-input textarea::-webkit-input-placeholder {
    color: #B7CCED;
    font-family: Noto Sans SC;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
  }

  .main-assess-input textarea:-moz-placeholder {
    color: #B7CCED;
    font-family: Noto Sans SC;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
  }

  .main-assess-input textarea:-ms-input-placeholder {
    color: #B7CCED;
    font-family: Noto Sans SC;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
  }

  .main-assess-activity {
    position: relative;
    background: #FFFFFF;
    border-radius: 4px;
    width: 516px;
    height: 86px;
    margin: 15px 0 0 0;
    display: inline-block;
  }

  .main-assess-activity-txt {
    font-family: Noto Sans SC;
    font-size: 14px;
    line-height: 24px;
    color: #FFFFFF;
    width: 80px;
    height: 24px;
    background: #1055C1;
    border-radius: 0px 0px 4px 0px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .main-assess-activity-info {
    margin: 39px 0 0 49px;
  }

  .main-assess-activity-checkbox {
    height: 24px;
    width: auto;
    float: left;
    margin: 3px 14px 0 0;
    cursor: pointer;
  }

  .main-assess-activity-info-txt {
    font-family: Noto Sans SC;
    font-weight: 500;
    font-size: 18px;
    line-height: 30px;
    color: #1055C1;
    float: left;
  }

  .main-assess-txt {
    font-family: Noto Sans SC;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    color: #666666;
    margin: 20px 0 0 0;
  }

  .main-assess-btn {
    background: #1055C1;
    border-radius: 10px;
    font-family: Noto Sans SC;
    font-weight: 500;
    font-size: 16px;
    line-height: 56px;
    text-align: center;
    color: #FFFFFF;
    width: 180px;
    height: 56px;
    display: inline-block;
    margin: 16px 0 0 0;
    cursor: pointer;
  }

  .main-contact-container{
    text-align: center;
    margin: 29px 0 0 0;
    display: inline-block;
  }
  .main-contact-phrase{
    margin: 20px 0 0 0;
    float: left;
    position: relative;
  }
  .main-contact-phrase:nth-child(-n+3){
    margin-top: 0px;
  }
  .main-contact-phrase-img{
    height: 30px;
    width: auto;
    margin: -2px 25px 0 0;
    float: left;
  }
  .main-contact-phrase-txt{
    font-family: Noto Sans SC;
    font-size: 16px;
    line-height: 24px;
    color: #1055C1;
    float: left;
  }
  .main-contact-phrase:first-of-type{
    margin-right: 95px;
  }
  .main-contact-phrase:nth-of-type(4){
    margin-right: 49px;
  }
  .main-contact-wechat-hover{
      position: absolute;
      left: 10px;
      top: auto;
      z-index: 9;
  }

  .main-contact-wechat-hover-img-container{
      background: url('../assets/qr_code_border_img.png') no-repeat;
      padding: 8px;
      background-size: 148px auto;
  }
  .main-contact-wechat-hover-img{
      width: 131px;
      height: auto;
      margin-top: 9px;
  }

  .main-map-container{
    width: calc(100% - 378px);
    height: 480px;
    margin: auto;
    margin: 75px auto auto auto;
  }
  .main-map-in{
    height: 100%;
    width: 100%;
  }

  .popup-container {
    width: 740px;
    height: auto;
    margin: auto;
    position: fixed;
    top: 78px;;
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
  }

  .popAppointAssessSuccess.popup-container {
    width: 840px;
    top: 80px;
    background: #FFFFFF;
    text-align: center;
    padding: 99px 0 98px 0;
  }
  .popup-close-img-container {
    cursor: pointer;
    position: absolute;
    top: 29px;
    right: 34px;
  }

  .popup-close-img {
    width: 24px;
    height: auto;
  }

  .popAppointAssessSuccess .popup-close-img-container {
    top: 24px;
    right: 24px;
  }

  .popup-hint-icon-container {}

  .popup-hint-icon {
    height: 145px;
    width: auto;
  }

  .popup-hint {
    font-family: Noto Sans SC;
    font-size: 24px;
    line-height: 40px;
    text-align: center;
    color: #1055C1;
    width: 545px;
    display: inline-block;
    margin: 62px 0 0 0;
  }

  .popup-btn {
    background: #1055C1;
    border-radius: 10px;
    font-family: Noto Sans SC;
    font-weight: 500;
    font-size: 16px;
    line-height: 56px;
    text-align: center;
    color: #FFFFFF;
    width: 180px;
    height: 56px;
    display: inline-block;
    margin: 16px 0 0 0;
    cursor: pointer;
  }
  .popAppointAssessSuccess .popup-btn {
    margin: 51px 0 0 0;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/contactUs.vue